<template>
  <div class="full-size leaderboard-wrap">
    <div v-if="!loading" class="leaderboard--content vertical layout">
      <div
        v-if="!noData"
        id="top-audience-quiz"
        ref="leaderboard-content"
        class="top-audience"
      >
        <div
          class="box-audience-list"
          :class="{'horizontal layout center': topAudiences.length < minNumberOfDisplayedPlayer}"
        >
          <transition-group
            class="box-audience-wrapper"
            name="leaderboard"
            tag="ul"
            style="width: 100%; max-height: 100%"
          >
            <li
              v-for="(item,index) in listAudienceShow"
              :key="item.id"
              class="audience--item horizontal layout center"
              :class="{'final-animation': index == 0 && finalSlide}"
            >
              <div class="audience--rank" :class="{'visible': isAudienceRankVisible}">
                <span class="audience--rank-wrapper">
                  <span class="audience--rank-text font-weight-bold">{{ item.index }}</span>
                  <span
                    class="audience--rank-circle"
                    :class="{'white': isTextColourLight}"
                  />
                </span>
              </div>
              <div
                class="audience--bar"
                :class="{'dark-theme': isTextColourLight}"
              >
                <!-- Color bar layer 2-->
                <div
                  class="audience--bar-progress layer--2"
                  :style="{'width': item.oldPercent + '%', 'background-color': item.color}"
                  :class="{'animation': animation, 'has-leaderboard-swap': isNextLeaderboard}"
                >
                  <div class="px-3 audience--bar-info horizontal layout font-weight-bold layer--1">
                    <div class="bar--name">
                      <div class="team-name">
                        <span>{{ item.name | profanity }}</span>
                        <span v-if="canModifyLeaderboard" class="ml-3 action">
                          <span class="mr-2" @click="addManualPoints(item)">
                            <i
                              class="fas fa-arrow-alt-circle-up"
                            />
                            {{ $t('points') }}
                          </span>
                        </span>
                      </div>
                      <div class="team-member">
                        <span
                          v-for="(member, indexMember) in item.members"
                          v-show="indexMember < 10"
                          :key="indexMember"
                        >
                          {{ member.audienceEmoji }}
                          {{ member.audienceName | profanity }}
                        </span>
                        <span
                          v-if="item.members.length - 10 > 0"
                        > + {{ item.members.length - 10 }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Audience info layer 3 -->
                <div class="px-3 audience--bar-info horizontal layout font-weight-bold layer--3">
                  <div class="bar--name">
                    <div class="team-name">
                      <span>{{ item.name | profanity }}</span>
                      <span v-if="canModifyLeaderboard" class="ml-3 action">
                        <span class="mr-2" @click="addManualPoints(item)">
                          <i
                            class="fas fa-arrow-alt-circle-up"
                          />
                          {{ $t('points') }}
                        </span>
                      </span>
                    </div>
                    <div class="team-member">
                      <span
                        v-for="(member, indexMember) in item.members"
                        v-show="indexMember < 10"
                        :key="indexMember"
                      >{{ member.audienceEmoji }} {{ member.audienceName | profanity }}
                      </span>
                      <span
                        v-if="item.members.length - 10 > 0"
                      >+ {{ item.members.length - 10 }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="audience--points horizontal layout end">
                <CountPointLeaderboard
                  :old-point="item.oldPoint"
                  :total-point="item.totalPoint"
                  :has-leaderboard-swap="isNextLeaderboard"
                />
                <NewPoint
                  :item="item"
                />
              </div>
            </li>
          </transition-group>
        </div>

        <div
          v-show="showWinner && showCarousel && !isBackstage"
          class="winner horizontal layout center center-justified animate__animated animate__bounceIn"
          :class="{'white': isTextColourLight}"
        >
          <div class="close-icon pointer small" @click="toggleCarousel">
            <i class="fas fa-times" />
          </div>

          <div v-if="!topWinnerStr && topAudiences.length" class="winner-list-top">
            <div class="box-winer">
              <div class="winner-name">
                <span>{{ topAudiences[0].name | profanity }}</span>
              </div>
              <div class="winner-emoji">
                {{ topAudiences[0].audienceEmoji }}
              </div>
            </div>
            <div class="team-member" :class="fontSizeMemberWinner">
              <span
                v-for="(member, indexMember) in topAudiences[0].members"
                v-show="indexMember < 10"
                :key="indexMember"
              >{{ member.audienceEmoji }} {{ member.audienceName | profanity }}</span>
              <span
                v-if="topAudiences[0].members.length - 10 > 0"
              >+ {{ topAudiences[0].members.length - 10 }}</span>
            </div>
            <div class="winner-point">
              {{ topAudiences[0].totalPoint | formatTotalPoint }}
              <span
                class="short-cut-text"
              >{{ $t("points") }}</span>
            </div>
          </div>
          <div v-show="topWinnerStr" class="winner-list-top">
            <div class="text-center winner-title" v-html="$t('weHaveWinners', {msg: countWinner})" />
            <div class="marquee">
              <div class="marquee--text" :style="{'animation': timeRunbanner}">
                {{ $t("congratulationsTo") }} {{ topWinnerStr }}!
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="scrollShow && !noData"
        class="pt-1 arrow-grid animate__animated animate__flash animate__slow animate__delay-5s"
        :class="{'disabled': scrollDisable}"
      >
        <i class="fas fa-chevron-down arrow-down" @click="scrollBottom" />
      </div>

      <div v-if="noData" class="no-data horizontal layout center center-justified">
        <div>
          <strong class="quiz--result font-weight-bold">{{ $t("noResultYet") }}</strong>
          <p class="quiz--result-desc">
            {{ $t("theTopQuizPlayer") }}
          </p>
        </div>
      </div>
    </div>
    <div v-if="loading" class="horizontal layout center center-justified full-size">
      <div class="text-center">
        <div class="quiz--result">
          {{ $t("loadingResult") }}...
        </div>
        <Loading style="margin: 0 auto" />
      </div>
    </div>
    <AddManualPointPopup
      v-if="addPointVisible"
      :data="addPointData"
      :audiences="listAudienceShow"
      @ok="addPointOk"
      @close="addPointClose"
    />
  </div>
</template>
<script>
import confetti from 'canvas-confetti'
import * as Sentry from '@sentry/vue'
import { mapActions, mapGetters } from 'vuex'
import Constant from '@/constant'
import Loading from '@/components/Loading'
import Util from '@/util'
import EventBus from '@/eventBus'
import Socket from '@/socket'
import SlideApi from '@/api/slide'
import LeaderboardApi from '@/api/leaderboard'
import CountPointLeaderboard from '@/components/presentations/CountPointLeaderboard.vue'
import NewPoint from '@/components/presentations/NewPoint.vue'
import AddManualPointPopup from '@/components/AddManualPointPopup'
import LeaderboardMixin from './LeaderboardMixin.vue'

export default {
  components: {
    Loading,
    CountPointLeaderboard,
    AddManualPointPopup,
    NewPoint,
  },
  mixins: [LeaderboardMixin],
  props: {
    showCarousel: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loading: true,
      topAudiences: [],
      animation: false,
      noData: false,
      finalSlide: false,
      showWinner: false,
      topWinnerStr: '',
      countWinner: null,
      myReq: null,
      timeOut1: null,
      timeOut2: null,
      timeOut3: null,
      scrollShow: true,
      scrollDisable: false,
      listAudienceShow: [],
      blockAudiences: [],
      timeRunbanner: '',
      minNumberOfDisplayedPlayer: 10,
      fontSizeMemberWinner: '',
      addPointData: {},
      addPointVisible: false,
    }
  },
  computed: {
    ...mapGetters(['isTextColourLight']),
    previousLeaderboard() {
      if (this.isFirstLeaderboard || !this.leaderboardIds) return null
      if (!this.$store.state.leaderboardTeamData) return null
      const currentIndex = this.leaderboardIds.indexOf(this.slideActive.id)
      const prevIndex = currentIndex - 1
      if (prevIndex === -1) return null
      return this.$store.state.leaderboardTeamData[this.leaderboardIds[prevIndex]]
    },
  },
  watch: {
    '$store.state.slideActive': function () {
      this.checkShowScroll()
    },
  },
  mounted() {
    this.updateSlideActiveAction({
      audiencesCount: null,
    })

    this.$emit('showWinner', null)
    this.getData()
    const self = this
    EventBus.$on('sort-slide', () => {
      self.getData()
    })
    EventBus.$on('onKeyboard', (e) => {
      if (self.$store.state.slideActive.type === 'leaderboard') {
        self.handleSlideControlsKeydown(e)
      }
    })

    try {
      if (localStorage.getItem('blockAudiences')) {
        this.blockAudiences = JSON.parse(localStorage.getItem('blockAudiences'))
      }
    } catch (error) {
      Sentry.captureException(error)
      this.blockAudiences = []
    }

    if (this.$store.state.sharePresentation) {
      Util.disallowPDFRender()
    }
  },
  destroyed() {
    EventBus.$off('sort-slide')

    if (this.myReq) {
      window.cancelAnimationFrame(this.myReq)
    }
    if (this.timeOut1) {
      window.clearTimeout(this.timeOut1)
      this.timeOut1 = null
    }
    if (this.timeOut2) {
      window.clearTimeout(this.timeOut2)
      this.timeOut2 = null
    }
    if (this.timeOut3) {
      window.clearTimeout(this.timeOut3)
      this.timeOut3 = null
    }

    document.body.classList.remove('hide-firework')
    Util.allowPDFRender()
  },
  methods: {
    ...mapActions(['updateSlideActiveAction', 'setSyncLoadingAction']),
    addManualPoints(item) {
      const data = {
        ...item,
        audienceId: null,
        audienceTeam: item.id,
        slideId: this.$store.state.slideActive.id,
        presentationId: this.presentation.id,
      }
      this.addPointData = data
      this.addPointVisible = true
      Util.mixpanelTracking(
        'Presentation Editor',
        'Leaderboard > Add manual point > Open popup',
        'Individual leaderboard',
      )
    },
    addPointOk() {
      this.getData(true)
    },
    addPointClose() {
      this.addPointVisible = false
    },
    checkInfinityScroll() {
      const listElm = document.querySelector('#top-audience-quiz')
      if (listElm) {
        listElm.addEventListener('scroll', () => {
          if (
            listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight - 50
          ) {
            if (this.listAudienceShow.length < this.topAudiences.length) {
              const from = this.listAudienceShow.length
              let to = from + 9
              if (this.topAudiences.length < to) {
                to = this.topAudiences.length
              }
              const arr = this.topAudiences.slice(from, to)
              this.listAudienceShow = this.listAudienceShow.concat(arr)
            }
          }
        })
      }
    },
    checkCurrentScore() {
      let check = false

      this.topAudiences.forEach((item) => {
        if (item.oldPoint != item.totalPoint) {
          check = true
        }
      })
      return check
    },
    checkHasQuizSlideBeforeLeaderboard(index, slides) {
      let hasQuizSlide = false
      for (let i = 0; i < index; i++) {
        if (slides[i].type === 'pickAnswer') {
          hasQuizSlide = true
          break
        }
      }
      return hasQuizSlide
    },
    async getData(reload) {
      this.loading = true
      if (!this.$store.state.swapLeaderboard) {
        EventBus.$emit('leaderboard-loaded', false)
      }
      this.noData = false
      this.finalSlide = false
      this.showWinner = false
      this.$emit('showWinner', null)
      this.animation = false

      if (this.myReq) {
        window.cancelAnimationFrame(this.myReq)
      }

      const { slides } = this.presentation

      const slidesQuiz = slides.filter((item) => {
        return item.type === 'pickAnswer'
      })

      const index = Util.getIndexSlide(slides, this.$store.state.slideActive.id)
      let indexQuiz = 0
      if (slidesQuiz.length) {
        indexQuiz = Util.getIndexSlide(
          slides,
          slidesQuiz[slidesQuiz.length - 1].id,
        )
      }
      if (index > indexQuiz) {
        this.finalSlide = true
      }
      this.updateSlideActiveAction({
        timestampLeaderboard: new Date().getTime(),
      })

      // Config.api.getResultLeaderboard
      const slideId = this.$store.state.slideActive.id
      const presentationId = this.presentation.id || this.$route.params.id

      if (!this.checkHasQuizSlideBeforeLeaderboard(index, slides)) {
        this.noData = true
        this.loading = false
        this.updateSlideActiveAction({
          audiencesCount: Util.numberWithCommas(0),
        })
        return
      }

      const payloadLeaderboard = {
        presentationId,
        slideId: this.$store.state.slideActive.id,
        finalSlide: this.finalSlide,
        accessCode: this.presentation.uniqueAccessCode,
        order: this.$store.state.slideActive.order,
        sharePresentation: this.$store.state.sharePresentation,
        timestampFile: this.$store.state.slideActive.timestampLeaderboard,
      }

      if (this.$store.state.isAdmin) {
        payloadLeaderboard.sharePresentation = true
      }

      try {
        this.checkSlideMovingDirectionAction(this.slideActive.id)

        if (index <= indexQuiz) {
          document.body.classList.add('hide-firework')
        }
      } catch {
        // do nothing
      }
      try {
        const res = await LeaderboardApi.createSlideLeaderboardToggle(payloadLeaderboard)
        if (slideId != this.$store.state.slideActive.id) {
          return
        }
        EventBus.$emit('leaderboard-loaded', true)
        let total = 0
        if (!res.body.totalAudiences) res.body.totalAudiences = 0
        if (!res.body.teams) res.body.teams = []
        if (!res.body.teams.length) {
          this.noData = true
        }
        if (res.body.teams.length) {
          total = res.body.teams[0].totalPoint
        }
        this.updateSlideActiveAction({
          audiencesCount: Util.numberWithCommas(res.body.teams.length),
        })

        res.body.teams.forEach((team) => {
          team.color = this.getColor(team)
          team.members = res.body.audiences.filter((au) => {
            return au.audienceTeam === team.id
          })
        })
        res.body.teams.forEach((item) => {
          item.oldPercent = (item.oldPoint / total) * 100 || 1
        })

        this.topAudiences = res.body.teams
        if (!this.$store.state.leaderboardTeamData) {
          this.$store.state.leaderboardTeamData = {}
        }
        this.$store.state.leaderboardTeamData[this.slideActive.id] = this.topAudiences
        this.countWinner = res.body.countTeamWinner
        this.topWinnerStr = res.body.topTeamStr
        if (res.body.lastTeamName) {
          if (this.countWinner == 2) {
            this.topWinnerStr = `${this.topWinnerStr} ${this.$t('and')} ${res.body.lastTeamName}`
          } else if (this.countWinner > 2) {
            this.topWinnerStr = `${this.topWinnerStr}, ${this.$t('and')} ${res.body.lastTeamName}`
          }
        }

        if (this.topWinnerStr.length) {
          const timeRunBanner =
            25 + parseInt(this.topWinnerStr.length / this.minNumberOfDisplayedPlayer, 10)
          this.timeRunbanner = `marquee ${timeRunBanner}s linear infinite`
        } else {
          this.timeRunbanner = 'marquee 25s linear infinite'
        }

        this.topAudiences.push()
        this.loading = false
        this.animation = true
        const self = this
        let timeWait = 4000
        if (this.isNextLeaderboard) {
          timeWait = 4500
        }
        if (!this.checkCurrentScore()) {
          timeWait = 0
        }
        this.timeOut1 = setTimeout(() => {
          this.topAudiences.forEach((item, key) => {
            item.oldPercent = (item.totalPoint / total) * 100
            if (!item.oldPercent) {
              item.oldPercent = 1
            }

            if (key >= this.minNumberOfDisplayedPlayer) {
              item.oldPoint = item.totalPoint
            }
          })

          this.timeOut2 = setTimeout(() => {
            if (this.$store.state.sharePresentation) {
              setTimeout(() => {
                Util.allowPDFRender()
              }, 2000)
            }
            if (
              this.finalSlide &&
              this.topAudiences.length &&
              this.topAudiences[0].totalPoint
            ) {
              this.showWinner = true
              this.$emit('showWinner', this.$store.state.slideActive.id)
              const canvas = document.getElementById('firework-canvas')
              if (!canvas) return
              canvas.confetti =
                canvas.confetti ||
                confetti.create(canvas, {
                  resize: true,
                })
              const colors = Constant.colorsHex.filter((item, key) => {
                return item && key < this.minNumberOfDisplayedPlayer
              })

              const _startFirework = function () {
                if (self.$store.state.isScreenCapture) return
                let start = null
                let count = 0
                let timeFirework = 250
                // eslint-disable-next-line
                function step(timestamp) {
                  if (count == 3) {
                    timeFirework = 800
                  }
                  if (!start) start = timestamp
                  const progress = timestamp - start
                  if (progress > timeFirework) {
                    start = null
                    count++
                    canvas.confetti({
                      startVelocity: 5,
                      spread: 360,
                      ticks: 200,
                      decay: 0.98,
                      particleCount: 80,
                      shapes: ['circle'],
                      colors,
                      zIndex: 100,
                      origin: {
                        x: Math.random(),
                        // since they fall down, start a bit higher than random
                        y: Math.random() - 0.3,
                      },
                    })
                  }
                  self.myReq = window.requestAnimationFrame(step)
                }
                self.myReq = window.requestAnimationFrame(step)
              }
              this.timeOut3 = setTimeout(() => {
                _startFirework(false)
                this.timeOut3 = null
              }, 500)

              let countCharactorMemberWinner = ''
              if (this.topAudiences[0].members) {
                this.topAudiences[0].members.forEach((mem, key) => {
                  countCharactorMemberWinner += mem.audienceName
                  if (key !== this.topAudiences[0].members.length - 1) {
                    countCharactorMemberWinner += ' '
                  }
                })
              }
              if (countCharactorMemberWinner.length > 150) {
                this.fontSizeMemberWinner = 'size-1'
              }
              if (countCharactorMemberWinner.length > 200) {
                this.fontSizeMemberWinner = 'size-2'
              }
              if (countCharactorMemberWinner.length > 250) {
                this.fontSizeMemberWinner = 'size-3'
              }
              if (countCharactorMemberWinner.length > 300) {
                this.fontSizeMemberWinner = 'size-4'
              }
              if (countCharactorMemberWinner.length > 350) {
                this.fontSizeMemberWinner = 'size-5'
              }
              if (countCharactorMemberWinner.length > 400) {
                this.fontSizeMemberWinner = 'size-6'
              }
            }
            this.timeOut2 = null
          }, timeWait)
          this.timeOut1 = null
          this.checkShowScroll()
        }, 200)

        const arrAudiences = []
        for (let i = 0; i < this.topAudiences.length; i++) {
          if (i < this.minNumberOfDisplayedPlayer) {
            arrAudiences.push(this.topAudiences[i])
          } else {
            this.topAudiences[i].oldPoint = this.topAudiences[i].totalPoint
          }
        }

        arrAudiences.sort(this.teamSorter)

        if (this.isFirstLeaderboard || !this.isNextLeaderboard || this.topAudiences.length > 200) {
          // show the leaderboard without animation from previous leaderboard (because we dont have prev leaderboard)
          this.listAudienceShow = arrAudiences
          this.isShowIndex = true
        } else {
          // show the leaderboard with animation, transition from prev leaderboard to the new leaderboard
          this.listAudienceShow = this.getLeaderboardToBeAnimated(this.topAudiences, this.previousLeaderboard)

          if (this.isLeaderboardRankChange(this.topAudiences, this.previousLeaderboard)) {
            setTimeout(() => {
              this.listAudienceShow = arrAudiences
              // show the index after rearranging the leaderboard
              setTimeout(() => {
                this.isShowIndex = true
              }, 500)
            }, 2500)
          } else {
            this.isShowIndex = true
            this.listAudienceShow = arrAudiences
          }
        }
        this.$store.state.lastViewLeaderboardId = this.slideActive.id

        if (!this.$store.state.sharePresentation &&
        !this.$store.state.isAdmin &&
        !this.$store.state.isDisableEditPresentation &&
        this.$store.state.controllerSocketId === Socket.getSocketId()) {
          SlideApi.updateNextSlideById(presentationId, {
            activeSlide: this.$store.state.slideActive.id,
            socketId: Socket.getSocketId(),
            accessCode: this.presentation.uniqueAccessCode,
            sharePresentation: this.$store.state.sharePresentation,
            reload,
            from: 'leaderboard-team',
          })
            .then(
              () => {
              },
              (err) => {
                if (Sentry && err.status) {
                  Sentry.captureException(`Presenter put next slide leaderboard, status: ${err.status}`)
                }
              },
            )
        }

        setTimeout(() => {
          this.checkInfinityScroll()
        }, 1000)
      } catch {
        this.setSyncLoadingAction(3)
      }
    },
    checkShowScroll() {
      setTimeout(() => {
        const container = this.$refs['leaderboard-content']
        this.scrollShow = container && container.scrollHeight > container.clientHeight
      })
    },
    getColor(team) {
      return team.color || Util.getAhaColorLegacy(team.id)
    },
    handleSlideControlsKeydown(e) {
      if (this.$store.getters.isPresenting) {
        if (e.code == 'ArrowDown') {
          this.scrollBottom()
        } else if (e.code == 'ArrowUp') {
          this.scrollTop()
        }
      }
    },
    scrollBottom() {
      const container = this.$refs['leaderboard-content']

      if (!container) return

      Util.scrollToElement(container, {
        behavior: 'smooth',
        top: container.scrollTop + 400,
      })

      if (container.scrollTop + container.clientHeight === container.scrollHeight) {
        this.scrollDisable = true
      }
    },
    scrollTop() {
      const container = this.$refs['leaderboard-content']

      if (!container) return

      this.scrollDisable = false

      Util.scrollToElement(container, {
        behavior: 'smooth',
        top: container.scrollTop - 400 < 0 ? 0 : container.scrollTop - 400,
      })
    },

    toggleCarousel() {
      this.$emit('toggleShowCarousel', 'team', this.$store.state.slideActive.id)
    },
    getLeaderboardToBeAnimated(newLeaderboard, oldLeaderboard) {
      if (!newLeaderboard || !oldLeaderboard) return null
      const newLeaderboardMap = Util.fromArrayToMap(newLeaderboard, 'id')
      oldLeaderboard.sort(this.teamSorter)
      const audiencesRemoved = oldLeaderboard.filter((item) => {
        return newLeaderboard.map((i) => i.id).includes(item.id)
      }).map((item) => {
        return newLeaderboardMap[item.id]
      })

      const audiencesAdded = newLeaderboard.filter((item) => {
        return !oldLeaderboard.map((i) => i.id).includes(item.id)
      })
      const animatingLeaderboard = audiencesRemoved.concat(audiencesAdded)

      return animatingLeaderboard.slice(0, this.minNumberOfDisplayedPlayer)
    },
    isLeaderboardRankChange(newLeaderboard, oldLeaderboard) {
      if (!newLeaderboard || !oldLeaderboard) return false
      const oldIds = oldLeaderboard.map((i) => i.id).slice(0, this.minNumberOfDisplayedPlayer)
      const newIds = newLeaderboard.map((i) => i.id).slice(0, this.minNumberOfDisplayedPlayer)
      return JSON.stringify(oldIds) !== JSON.stringify(newIds)
    },
    teamSorter(a, b) {
      if (a.index < b.index) return -1
      if (a.index > b.index) return 1
      if (a.name < b.name) return 1
      if (a.name > b.name) return -1
      return 0
    },

  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
@import "@/assets/scss/animation.scss";
.leaderboard-wrap .audience--bar {
  height: auto;
}

.team-member {
  font-size: 20px;
  font-weight: normal;
  line-height: 1.25;
  margin-bottom: 5px;

  span {
    margin-right: 12px;
  }
}
.bar--name {
  width: 100%;
}

.team-name {
  line-height: 35px;
  margin-top: 8px;
}

.winner {
  .team-member {
    font-size: 33px;
    margin: 10px;

    &.size-1 {
      font-size: 28px;
    }
    &.size-2 {
      font-size: 26px;
    }
    &.size-3 {
      font-size: 24px;
    }
    &.size-4 {
      font-size: 22px;
    }
    &.size-5 {
      font-size: 20px;
    }
    &.size-6 {
      font-size: 16px;
    }
  }
}

.arrow-grid {
  z-index: 4;
}

.arrow-down {
  position: relative;
  top: -11px;
}

.close-icon {
  position: absolute;
  top: 3px;
  right: 8px;
  opacity: 0.5;

  &:hover {
    opacity: 1;
  }
}

.team-name__text {
  max-width: 60%;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: top;
}

</style>
